import { MiscLedgerPage } from './_shared/MiscLedgerPage';
import { MiscLedgerDirection } from '@/services/api/frontdeskOps.types';

export function MiscRevenuePage() {
  return <MiscLedgerPage direction={MiscLedgerDirection.REVENUE} />;
}
